import { CategoricalBarChartLegendProps } from '../types/categorical-bar-chart.js';

/**
 * Legend slot component.
 */
export const Legend = (props: CategoricalBarChartLegendProps) => null;

Legend['displayName'] = 'CategoricalBarChart.Legend';
